<template>    
    <BaseModal
        :id="'static-rooms-discharges-applied'"
        :title="'Discharges Applied'"
        :message="'Here is a list of all discharges that have been applied today.'"
        size="lg"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="col-md-12 px-0 pb-0 pt-4">
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="form_data.search">
                </div>
            </div>
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :content_align_x="'pt-0'" alt="discharges_applied">
                <template v-slot:more-fields>
                    <div class="col-md-12 px-0 pb-0">
                        <button class="modal__buttons__item w-auto px-3 mt-2 mr-2" v-html="'Apply search'" @click="getDischargesApplied()" :disabled="loading"/>
                    </div>
                </template>
            </FormDynamic>
            <div v-if="loading" class="text-center w-100" style="height: 3rem !important;">
                <div class="spinner-border mt-4" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="tab-content mt-4" v-if="discharges_applied.length">
                <div class="tab-pane fade active show" id="listation">
                    <div class="row mb-0 no-gutters">
                        <div class="col-lg-12">
                            <v-card>
                                <DinamicTable
                                    :headers="table_headers"
                                    :items="discharges_applied"
                                    :search="''"
                                    :size="30"
                                />
                            </v-card>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="!discharges_applied.length && !loading" class="alert alert-warning mt-2" role="alert">
                No records available
            </div>
            <CentralLiteButtons :done="true"/>
        </template>
    </BaseModal>
</template>

<script>
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import FormDynamic      from    '@/components/FormDynamic.vue'
import DinamicTable from '@/components/DinamicTable'
import BaseModal from '@/components/BaseModal'
import CentralLiteButtons from '@/components/CentralLiteButtons';
import DischargesAppliedFormResources from './discharges_applied_form_resources';

export default {

    name:   'DischargesAppliedModal',
    props: [
        "rest_api",
        "breadcrumb",
        "array_options"
    ],

    components:{
        CentralLiteButtons,
        Breadcrumb,
        BaseModal,
        DinamicTable,
        FormDynamic
    },

    data(){
        return {
            discharges_applied: [],
            loading: true,
            form_data: DischargesAppliedFormResources.form_data,
            form_format: DischargesAppliedFormResources.form_format,
            table_headers: [
                {
                    text:   "Room",
                    value:  "room",
                },
                {
                    text:   "Bed Code",
                    value:  "bed_code"
                },
                {
                    text:   "Daily Assignment",
                    value:  "daily_assignment"
                },
                {
                    text:   "Associate",
                    value:  "associate_name"
                },
                {
                    text:   "Minutes",
                    value:  "minutes"
                },
            ],
        }
    },

    watch: {
        async 'form_data.date_to_search' ()
        {
            this.getDischargesApplied()
        }
    },

    methods:{
        async getDischargesApplied()
        {
            if(this.form_data.date_to_search)
            {
                this.discharges_applied = []
                this.loading = true
                const response = await this.post(`${this.rest_api}/discharges_applied`, this.form_data)
                this.loading = false

                if(response.status)
                {
                    this.discharges_applied = response.data.data
                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.notyfMesg('Select a date', 'error')
            }

        },
    },

    mounted(){

    }
    
}
</script>